import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getSavedList = normalize.getSavedList(function (options) {
  var _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  tt.getSavedFileList({
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);
export default getSavedList;